import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ProductSubtypeEnum } from '@app/models/enums/product-subtype.enum';

@Injectable({providedIn: 'root'})
export class TfMetaService {

    descriptionMetaTag = null;

    titleData: Record<ProductSubtypeEnum, string> = {
        [ProductSubtypeEnum.ge]: 'Taqman Gene Expression Assays',
        [ProductSubtypeEnum.gx]: 'Taqman Gene Expression Arrays',
        [ProductSubtypeEnum.snp]: 'TaqMan SNP Genotpying Assays',
        [ProductSubtypeEnum.cnv]: 'TaqMan Copy Number Assays',
        [ProductSubtypeEnum.microrna_advanced]: 'TaqMan Advanced miRNA Assays',
        [ProductSubtypeEnum.microrna_array]: 'TaqMan miRNA Arrays',
        [ProductSubtypeEnum.microrna_primary]: 'TaqMan Primary miRNA Assays',
        [ProductSubtypeEnum.microrna_classic]: 'TaqMan Classic miRNA Assays',
        [ProductSubtypeEnum.microrna_all]: '',
        [ProductSubtypeEnum.microbre_all]: ''
    }

    data: Record<ProductSubtypeEnum, string> = {
        [ProductSubtypeEnum.ge]: 'predesigned TaqMan Gene Expression Assays, real-time PCR primers and probes',
        [ProductSubtypeEnum.gx]: 'affordable TaqMan Arrays for all of your qPCR Needs',
        [ProductSubtypeEnum.snp]: 'TaqMan 5\'-nuclease assay chemistry provides a fast and simple way to get single nucleotide polymorphism (SNP) genotyping results',
        [ProductSubtypeEnum.cnv]: 'TaqMan Copy Number Assays employ TaqMan MGB probe chemistry to evaluate the copy number of genomic DNA targets using real-time PCR',
        [ProductSubtypeEnum.microrna_advanced]: 'TaqMan MicroRNA Assays for miRNA research—from isolation through discovery, profiling, quantitation, validation, and functional analysis',
        [ProductSubtypeEnum.microrna_array]: 'affordable TaqMan Arrays for all of your qPCR Needs',
        [ProductSubtypeEnum.microrna_primary]: 'TaqMan MicroRNA Assays for miRNA research—from isolation through discovery, profiling, quantitation, validation, and functional analysis',
        [ProductSubtypeEnum.microrna_classic]: 'TaqMan MicroRNA Assays for miRNA research—from isolation through discovery, profiling, quantitation, validation, and functional analysis',
        [ProductSubtypeEnum.microrna_all]: '',
        [ProductSubtypeEnum.microbre_all]: ''
    }

    constructor(
        private titleService: Title
    ) {
        this.descriptionMetaTag = document.querySelector('meta[name="description"]');
    }

    setMeta(product: ProductSubtypeEnum, resultsCount?: number): void {
        this.setTitle(product, resultsCount);
        this.setDescription(product, resultsCount);
    }

    setTitle(product: ProductSubtypeEnum, resultsCount?: number): void {

        if( resultsCount != undefined ) {
            this.titleService.setTitle(this.titleData[product]);
            return;
        }

        this.titleService.setTitle(this.data[product]);

    }

    setDescription(product: ProductSubtypeEnum, resultsCount?: number): void {

        if (resultsCount != undefined) {
            this.descriptionMetaTag.setAttribute('content', `${resultsCount} ${this.data[product]}`);
            return;
        }

        this.descriptionMetaTag.setAttribute('content', this.data[product]);

    }

}
